module.exports = __webpack_public_path__ + "img/member-checked.ed5b8538.png";